import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { VerifyEmailPage } from "~/pages/verify-email.page";

/**
 * Email-verification landing + token handoff route.
 *
 * - If a `token` is present, the page forwards to Better Auth's
 *   `/api/auth/verify-email?token=...&callbackURL=...` endpoint.
 * - If no token is present, this route acts as the post-verify callback
 *   destination and forwards users to `?redirect=...`.
 *
 * Also reachable directly without a token — in that case the page shows
 * the resend UI so a user can request a fresh verification link.
 */
export const Route = createFileRoute("/verify-email")({
  validateSearch: z.object({
    token: z.string().optional(),
    redirect: z
      .string()
      .optional()
      .refine((v) => !v || (v.startsWith("/") && !v.startsWith("//"))),
    error: z.string().optional(),
  }),
  component: VerifyEmailPage,
});
